import { endpoints } from "../constants/endpoints";
import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

type FetchUserByEmailProps = {
  emailId: string;
};

type FetchAssignedOutletsProps = {
  userEmail: string;
  page: number | undefined;
  limit: number | undefined;
  search?: string;
  download?: string;
  startDate?: string;
  endDate?: string;
  sortOrder?: string;
};

export const fetchUsersByEmail = async (props: FetchUserByEmailProps) => {
  const endpointsUrl = `${endpoints.getUserByEmail}/${props.emailId}`;
  try {
    return await api.get(endpointsUrl, {
      params: {
        orgId: getApiOrganizationId(),
      },
    });
  } catch (error) {
    throw new Error("Failed to fetch seller");
  }
};

export const fetchAssignedOutlets = async (
  props: FetchAssignedOutletsProps
) => {
  try {
    return await api.get(`assigned-outlets/${props.userEmail}`, {
      params: {
        page: props.page,
        limit: props.limit,
        search: props.search,
        startDate: props.startDate,
        endDate: props.endDate,
        download: props.download,
        sortOrder: props.sortOrder,
        orgId: getApiOrganizationId(),
      },
    });
  } catch (error) {
    throw new Error("Failed to fetch assigned outlets");
  }
};
